import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Button } from './button.js';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './dialog.js';
// A lightweight one-click confirm — title, description, single confirm button.
// For lower-stakes-but-still-destructive actions (revoke an invite, deprovision
// a product). For the heavy, sign-people-out actions (suspend / archive / remove
// a person) use ConfirmDestructive, which makes you type the entity name.
export function ConfirmAction({ open, onOpenChange, title, description, confirmLabel = 'Confirm', variant = 'destructive', onConfirm, }) {
    const [busy, setBusy] = useState(false);
    async function go() {
        if (busy)
            return;
        setBusy(true);
        try {
            await onConfirm();
            onOpenChange(false);
        }
        finally {
            setBusy(false);
        }
    }
    return (_jsx(Dialog, { open: open, onOpenChange: (o) => { if (!busy)
            onOpenChange(o); }, children: _jsxs(DialogContent, { children: [_jsxs(DialogHeader, { children: [_jsx(DialogTitle, { children: title }), description && _jsx(DialogDescription, { children: description })] }), _jsxs("div", { className: "flex justify-end gap-2 pt-1", children: [_jsx(Button, { type: "button", variant: "ghost", disabled: busy, onClick: () => onOpenChange(false), children: "Cancel" }), _jsx(Button, { type: "button", variant: variant, disabled: busy, onClick: () => void go(), children: busy ? 'Working…' : confirmLabel })] })] }) }));
}
